import React, { ReactNode, ComponentProps } from 'react'
import { VariantProps } from '@stitches/react'
import { Text } from 'components/Text'
import { Icon } from 'components/Icon'
import { IconName } from 'components/Icon/iconNames'
import { TabsRoot, StyledContent, StyledList, StyledTrigger } from './Tabs.styles'

export type Tab = {
  label: string
  icon?: IconName
  content: ReactNode
  href: string
}
type TabsVariants = VariantProps<typeof TabsRoot>

type TabsOwnProps = ComponentProps<typeof TabsRoot>
export type TabsProps = TabsOwnProps &
  TabsVariants & {
    tabs: Tab[]
    defaultTab: string
    onValueChange: (value: string) => void
    petDetail?: boolean
  }

export const Tabs = ({ tabs, defaultTab, onValueChange, petDetail }: TabsProps) => {
  return (
    <TabsRoot defaultValue={defaultTab} onValueChange={onValueChange}>
      <StyledList>
        {tabs.map(({ label, icon, href }) => (
          <StyledTrigger value={label} key={label} petDetail={petDetail}>
            {icon && <Icon name={icon} size="3" />}
            <Text size="body" weight="medium" className="label-text">
              {label}
            </Text>
          </StyledTrigger>
        ))}
      </StyledList>
      {tabs.map(({ label, content }) => (
        <StyledContent key={label} value={label}>
          {content}
        </StyledContent>
      ))}
    </TabsRoot>
  )
}

Tabs.displayName = 'Tabs'
